import React from 'react';
import { UrgencyBar } from '../components/UrgencyBar';
import { HeroSection } from '../components/HeroSection';
import { StorySection } from '../components/StorySection';
import { TestimonialSection } from '../components/TestimonialSection';
import { OfferSection } from '../components/OfferSection';
import { PricingSection } from '../components/PricingSection';
import { FaqSection } from '../components/FaqSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FinalCtaSection } from '../components/FinalCtaSection';
import { Footer } from '../components/Footer';
export function SalesPage() {
  return <div className="min-h-screen bg-softwhite font-sans text-charcoal selection:bg-sage selection:text-white" data-id="element-241">
      <UrgencyBar data-id="element-242" />

      <main data-id="element-243">
        <HeroSection data-id="element-244" />
        <StorySection data-id="element-245" />
        <TestimonialSection data-id="element-246" />
        <OfferSection data-id="element-247" />
        <PricingSection data-id="element-248" />
        <FaqSection data-id="element-249" />
        <GuaranteeSection data-id="element-250" />
        <FinalCtaSection data-id="element-251" />
      </main>

      <Footer data-id="element-252" />
    </div>;
}